import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SortOptionsService } from './../../services/sort-options.service';

const noop = () => {};

@Component({
  selector: 'app-reactive-form-field',
  templateUrl: './reactive-form-field.component.html',
  styleUrls: ['./reactive-form-field.component.scss'],
})
export class ReactiveFormFieldComponent implements OnInit, OnChanges {
  constructor(private sortOptionsService: SortOptionsService) {}
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input() fieldId: string = '';
  @Input() fieldName: string = '';
  @Input() customFormControl: UntypedFormControl;
  @Input() patternMatch: string;
  @Input() missingMsg: string;
  @Input() invalidMsg: string;
  @Input() invalidLengthMsg: string;
  @Input() invalidPatternMsg: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() tooltipText: string;
  @Input() required: boolean = false;
  @Input() disabled: boolean;
  @Input() disabledMsg: string = '';
  @Input() minlength: number;
  @Input() maxlength: number;
  @Input() noSort: boolean = false;
  @Input() fieldSize: string = 'small';
  @Input() showClearSelectionOption: boolean;
  @Input() type = 'text';
  @Input() inputClass = '';
  @Input() full: boolean;
  @Input() min: number;
  @Input() max: number;
  @Input() autocomplete: 'on' | 'off' = 'off';
  @Input() select: boolean = false;
  @Input() multiple: boolean = false;
  @Input() multiSelectMax: boolean = false;
  @Input() multiSelectMin: boolean = false;
  @Input() minSelectionErrorMsg: string;
  @Input() link: string;
  @Input() uniquePatternPropertyMsg: string;

  @Input() formMargin: number = 3;
  @Input() invalidNumberMsg: string;
  @Input() invalidEmailMsg: string;
  @Input() notUniqueMsg: string;
  @Input() selectValues: {
    label: string;
    value: string;
    disabled: boolean;
    tooltip?: string;
    icon?: string;
  }[] = [];
  @Input() inputSize: number = 5;
  @Input() labelSize: number = 3;
  @Input() loading: boolean = false;
  @Input() showInfoAsTooltip: boolean = true;
  @Input() showFormDivider: boolean = false;
  @Input() fullWidth: boolean = true;
  @Input() customValidationError: string = '';
  @Input() restrictSelectValuesSort: boolean = false;
  @Input() compareFieldErrMsg: string;

  // eslint-disable-next-line @angular-eslint/no-output-native

  ngOnChanges(change: SimpleChanges) {
    if (change?.selectValues?.currentValue?.length > 0 && !this.noSort) {
      if (!this.restrictSelectValuesSort) {
        this.selectValues = this.sortOptionsService.sortList(
          change?.selectValues?.currentValue,
          'label',
        );
      }
    }
    if (change?.invalidPatternMsg) {
      this.invalidPatternMsg = change?.invalidPatternMsg?.currentValue;
    }
  }

  ngOnInit(): void {
    this.invalidMsg = this.invalidMsg || this.label + ' is invalid!';
    this.missingMsg = this.missingMsg || this.label + ' is required!';
    this.placeholder = this.placeholder ?? this.label;
    if (this.full) {
      this.inputSize = 7;
      this.labelSize = 5;
      if (!this.label) {
        this.inputSize = 12;
        this.labelSize = 0;
      }
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  onChangeInputVal(event) {
    if (typeof event === 'string') {
      event = event?.trim();
      const currentValue = this.customFormControl?.value;
      const trimmedEvent = event?.trim();
      if (trimmedEvent !== currentValue) {
        this.customFormControl.setValue(trimmedEvent, { emitEvent: false });
      }
    }
    if (event) {
      this.selectedValue = null;
      this.writeValue(event);
    }
    this.change.emit(event);
  }

  selectedValue: any;
  writeValue(value: any): void {
    if (Array.isArray(value)) {
      this.selectedValue = (value as any[]).map((val) => ({
        value: val,
        label: val,
      }));
    }
  }

  shouldOptionBeDisabled(opt, value) {
    if (
      this.select &&
      this.multiple &&
      this.multiSelectMax &&
      this.selectedValue?.length === this.multiSelectMax
    ) {
      return this.selectedValue.map((val) => val.value).indexOf(opt) === -1;
    } else if (this.select && value.disableSelectOption) {
      return value.disableSelectOption;
    }
    return false;
  }

  @Output() iconClick = new EventEmitter();
  byCustomIconClick(clickedItem, event) {
    event?.stopPropagation();
    this.iconClick.emit(clickedItem);
  }
}
